import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as AuthActions from '../actions/Auth';
import * as HeaderActions from '../actions/Header';
import * as PasswordActions from '../actions/Password';
import ForgotPassword from '../components/ForgotPassword';

const mapStateToProps = (state: any) => {
  return {
    auth: state.auth,
    header: state.header,
    password: state.password,
  };
};

const mapDispatchToProps = (dispatch: any) => {
  return {
    authActions: bindActionCreators(AuthActions, dispatch),
    headerActions: bindActionCreators(HeaderActions, dispatch),
    passwordActions: bindActionCreators(PasswordActions, dispatch),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ForgotPassword);



// WEBPACK FOOTER //
// ./src/containers/ForgotPassword.tsx